import React from "react";

export function ItemCrop({ item }) {
  if (!item?.crop) return null;

  return (
    <div className="wiki-production">
      <h3 className="text-lg font-semibold mb-3 text-[var(--text-color)]">Crop Details</h3>

      <div className="production-entry mb-4 p-3 border border-[var(--border-color)] rounded">
        {/* Basic Info */}
        <div className="item-line">
          <span className="item-title">Tier:</span> <span>{item.tier ? item.tier : 0}</span>
        </div>

        <div className="item-line">
          <span className="item-title">Skill:</span> <span className="capitalize">Farming</span>
        </div>

        <div className="item-line">
          <span className="item-title">Required Level:</span> <span>{item.crop.plantingLvl || 0}</span>
        </div>

        {/* Time and Energy */}
        <div className="item-line">
          <span className="item-title">Grow Time:</span> <span>{`${item.crop.growTime} minute(s)`}</span>
        </div>

        <div className="item-line">
          <span className="item-title">Plant Energy Cost:</span> <span>{item.crop.plantingEnergy ? `⚡${item.crop.plantingEnergy * -1}` : 0} </span>
        </div>

        <div className="item-line">
          <span className="item-title">Harvest Energy Cost:</span> <span>⚡1 </span>
        </div>

        <div className="item-line">
          <span className="item-title">Watering Energy Cost:</span> <span>⚡0.5</span>
        </div>

        <div className="item-line">
          <span className="item-title">Total Energy Cost:</span> <span>⚡{(item.crop.plantingEnergy * -1) + 0.5 + 1}</span>
        </div>

        {/* Drops */}
        <div className="item-line">
          <span className="item-title">Exp:</span> <span>{item.crop.harvestExp}</span>
        </div>

        <div className="item-line">
          <span className="item-title">Result:</span> <span>{item.crop.result}</span>
        </div>
      </div>
    </div>
  );
}
